import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import { withTwoColLayout } from "../../../../../utils";
import PageSubheader from "../../../../../components/PageSubheader";
import Form from "../form";

interface Props {
  match: Match<{ cid: string; id: string }>;
  intl: IntlShape;
  backURL: string;
}

const UpdateRoundForm = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.inspection.round.form.update.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-inspection-round-form-update"
        goBackURL={backURL}
      />

      <Form {...props} edition />
    </>
  );
};

export default withTwoColLayout(injectIntl(UpdateRoundForm));
